module.exports = __webpack_public_path__ + "static/media/PT.9659af79.svg";